import React, { useEffect, useState } from 'react';
import { getProxies, addProxy } from '../api.js';


function proxyHealthLabel(value) {
  const key = String(value || '')
    .trim()
    .toLowerCase();

  const labels = {
    healthy: 'Работает',
    ok: 'Работает',
    active: 'Работает',
    online: 'Работает',
    warning: 'Внимание',
    degraded: 'Ограниченно',
    error: 'Ошибка',
    failed: 'Ошибка',
    offline: 'Недоступно',
  };

  return labels[key] || value || 'Нет данных';
}

function proxyCredentialLabel(value) {
  const key = String(value || '')
    .trim()
    .toLowerCase();

  if (
    key === 'secret'
    || key === 'password'
    || key === 'set'
  ) {
    return 'Скрыто';
  }

  return value || '—';
}


export default function Proxies() {
  const [proxies, setProxies] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const emptyForm = {
    host: '',
    port: '1080',
    proxy_type: 'socks5',
    username: '',
    password: '',
    country: '',
    max_sessions: '5',
  };

  const [form, setForm] = useState(emptyForm);

  const load = () => getProxies()
    .then(setProxies)
    .catch(() => {});

  useEffect(() => {
    load();
  }, []);

  const handleTypeChange = (proxyType) => {
    setForm({
      ...form,
      proxy_type: proxyType,
      port: proxyType === 'mtproto'
        ? '1443'
        : form.port,
      username: proxyType === 'mtproto'
        ? ''
        : form.username,
    });
  };

  const handleAdd = async () => {
    await addProxy({
      host: form.host,
      port: Number(form.port),
      proxy_type: form.proxy_type,
      username: form.proxy_type === 'mtproto'
        ? null
        : (form.username || null),
      password: form.password || null,
      country: form.country || null,
      max_sessions: Number(form.max_sessions),
    });

    setShowModal(false);
    setForm(emptyForm);
    load();
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 24,
        }}
      >
        <h1>Прокси</h1>
        <button
          className="btn-primary"
          onClick={() => setShowModal(true)}
        >
          + Добавить прокси
        </button>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Адрес</th>
              <th>Порт</th>
              <th>Тип</th>
              <th>Страна</th>
              <th>Доступ</th>
              <th>Состояние</th>
              <th>Сессии</th>
            </tr>
          </thead>
          <tbody>
            {proxies.length === 0 && (
              <tr>
                <td
                  colSpan={7}
                  style={{
                    textAlign: 'center',
                    color: '#a0aec0',
                  }}
                >
                  No proxies configured
                </td>
              </tr>
            )}

            {proxies.map((proxy) => (
              <tr key={proxy.id}>
                <td><strong>{proxy.host}</strong></td>
                <td>{proxy.port}</td>
                <td>{proxy.proxy_type}</td>
                <td>{proxy.country || '-'}</td>
                <td>
                  {proxy.proxy_type === 'mtproto'
                    ? (proxy.has_auth ? 'secret' : 'missing')
                    : (proxy.has_auth ? 'user/pass' : 'none')}
                </td>
                <td>
                  <span
                    className={`badge ${
                      proxy.is_healthy
                        ? 'badge-ok'
                        : 'badge-error'
                    }`}
                  >
                    {proxy.is_healthy ? 'healthy' : 'dead'}
                  </span>
                </td>
                <td>
                  {proxy.active_sessions} / {proxy.max_sessions}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="modal"
            onClick={(event) => event.stopPropagation()}
          >
            <h2>Добавить прокси</h2>

            <div className="form-grid">
              <div className="form-group">
                <label>Адрес</label>
                <input
                  value={form.host}
                  onChange={(event) => setForm({
                    ...form,
                    host: event.target.value,
                  })}
                  placeholder={
                    form.proxy_type === 'mtproto'
                      ? 'tg-ws-proxy'
                      : 'proxy.example.com'
                  }
                />
              </div>

              <div className="form-group">
                <label>Порт</label>
                <input
                  type="number"
                  value={form.port}
                  onChange={(event) => setForm({
                    ...form,
                    port: event.target.value,
                  })}
                />
              </div>

              <div className="form-group">
                <label>Тип</label>
                <select
                  value={form.proxy_type}
                  onChange={(event) => handleTypeChange(
                    event.target.value,
                  )}
                >
                  <option value="socks5">SOCKS5</option>
                  <option value="socks4">SOCKS4</option>
                  <option value="mtproto">MTProto</option>
                </select>
              </div>

              {form.proxy_type !== 'mtproto' && (
                <div className="form-group">
                  <label>Username</label>
                  <input
                    value={form.username}
                    onChange={(event) => setForm({
                      ...form,
                      username: event.target.value,
                    })}
                    autoComplete="off"
                  />
                </div>
              )}

              <div className="form-group">
                <label>
                  {form.proxy_type === 'mtproto'
                    ? 'MTProxy Secret'
                    : 'Password'}
                </label>
                <input
                  type="password"
                  value={form.password}
                  onChange={(event) => setForm({
                    ...form,
                    password: event.target.value,
                  })}
                  placeholder={
                    form.proxy_type === 'mtproto'
                      ? '32 hexadecimal characters'
                      : ''
                  }
                  autoComplete="new-password"
                />
              </div>

              <div className="form-group">
                <label>Страна</label>
                <input
                  value={form.country}
                  onChange={(event) => setForm({
                    ...form,
                    country: event.target.value,
                  })}
                  placeholder="RU"
                />
              </div>

              <div className="form-group">
                <label>Максимум сессий</label>
                <input
                  type="number"
                  value={form.max_sessions}
                  onChange={(event) => setForm({
                    ...form,
                    max_sessions: event.target.value,
                  })}
                />
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="btn-ghost"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn-primary"
                onClick={handleAdd}
                disabled={
                  !form.host
                  || (
                    form.proxy_type === 'mtproto'
                    && !form.password
                  )
                }
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
